import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { Drawer, Grid, Avatar, Typography } from '@material-ui/core/'
import { makeStyles } from '@material-ui/core/styles'
import apiUser from '../../../api/auth'
import DeleteModal from './components/index'
import InputGeogoding from './components/Geolocations'
import { logOut, signInAction } from '../../../modules/session/actions'
import myStoryIcon from '../../../assetss/img/myStoryIcon.svg'
import myStoryActive from '../../../assetss/img/myStoryActive.svg'
import setIcon from '../../../assetss/img/setIcon.svg'
import setIconActive from '../../../assetss/img/setIconActive.svg'
import bookmarkIcon from '../../../assetss/img/bookmarkIcon.svg'
import booksActive from '../../../assetss/img/booksActive.svg'
import arrowLogOut from '../../../assetss/img/arrowLogOut.svg'
import clsx from 'clsx'
import './index.scss'

const useStyles = makeStyles({
  paper: {
    height: 'calc(100% - 80px)',
    top: 80,
    zIndex: 100000,
    boxShadow: 'none',
  },
  linkStory: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    '&:hover': {
      opacity: '0.5',
    },
  },
  linkIcon: {
    marginRight: '25px',
    width: '32px',
  },
  linkBooks: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginTop: '25px',
    '&:hover': {
      opacity: '0.5',
    },
  },
  active: {
    color: '#FE794E',
  },
})

const SideBar = ({ openSide, setOpenSide, user, setOnSucssesDElete, disconnectUser }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { pathname } = useLocation()
  const [openDelete, setOpenDelete] = useState()
  const [openDeleteText, setOpenDeleteText] = useState()
  const classes = useStyles()

  const [address, setAdress] = useState('')

  const goTo = path => history.push(path)

  const updateUser = city => {
    apiUser.updateUser(user?.accessKey, {
      town: city,
      userUuid: user?.user?.uuid,
    }).then(res => {
      dispatch(signInAction({ ...user, user: { ...res.data.user } }))
    })
  }

  const toggleDrawer = (anchor, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setOpenSide(open)
  }

  const onOpenModal = () => {
    setOpenDeleteText(false)
  }

  const onDelete = () => {
    disconnectUser()
    apiUser.deleteProfile(user?.accessKey)
      .then(() => {
        onOpenModal()
        dispatch(logOut(null))
        setOpenSide(false)
        setOnSucssesDElete(true)
        setOpenDelete(prev => !prev)
        goTo('/')
      })
  }

  const onLogOut = path => {
    dispatch(logOut(null))
    history.push(path)
    setOpenSide(false)
    disconnectUser()
  }

  useEffect(() => {
    if (address?.label) {
      updateUser(address?.value?.structured_formatting?.main_text)
    }
  }, [address])

  const list = anchor => (
    <div
      className='list'
      role='permanent'
    >
      <Grid className='wrapperSideBarTop' container>
        <Typography className='titleSideBar'>Account</Typography>
        <Grid container direction='row' alignItems='center'>
          <Avatar className='avatar'>{user?.user?.name?.charAt(0)}</Avatar>
          <Typography className='userName'>{user?.user?.name}</Typography>
        </Grid>
        <InputGeogoding value={address} setValue={setAdress} defaultValue={user?.user?.town} />
      </Grid>
      <Grid className='borderSide' />
      <Grid className='wrapperSideBarBottom' container direction='column'>
        <Typography
          className={clsx(classes.linkStory, pathname === '/myStory' && classes.active)}
          onClick={() => {
            goTo('/myStory')
            setOpenSide(false)
          }}
        >
          {pathname === '/myStory' ? (
            <img className={classes.linkIcon} src={myStoryActive} alt='myStoryIcon' />
          ) : (
            <img className={classes.linkIcon} src={myStoryIcon} alt='myStoryIcon' />
          )}
          My stories
        </Typography>
        <Typography
          className={clsx(classes.linkBooks, pathname === '/myBookmarks' && classes.active)}
          onClick={() => {
            goTo('/myBookmarks')
            setOpenSide(false)
          }}
        >
          {pathname === '/myBookmarks' ? (
            <img className={classes.linkIcon} src={booksActive} alt='bookmarkIcon' />
          ) : (
            <img className={classes.linkIcon} src={bookmarkIcon} alt='bookmarkIcon' />
          )}
          Bookmarks
        </Typography>
        <Typography className={clsx(classes.linkBooks, openDelete && classes.active)} onClick={() => setOpenDelete(prev => !prev)}>
          {openDelete ? (
            <img className={classes.linkIcon} src={setIconActive} alt='bookmarkIcon' />
          ) : (
            <img className={classes.linkIcon} src={setIcon} alt='bookmarkIcon' />
          )}
          Settings
        </Typography>
        <Grid className='deleteProfileBox'>{openDelete && <Typography className='deleteProfile' onClick={() => setOpenDeleteText(true)}>Delete account</Typography>}</Grid>
      </Grid>
      <Grid container className='logOutFooter'>
        <Typography className='logOutText' onClick={() => onLogOut('/')}>
          <img className='logOutIcon' src={arrowLogOut} /> Log out
        </Typography>
        <Typography onClick={() => setOpenSide(false)} className='linkTerms'><span onClick={() => goTo('/terms')}>Terms of Use</span> / <span onClick={() => goTo('/privacy')}>Privacy policy</span></Typography>
        <Typography className='adress'>5B Baseyna str., Kyiv, 01024, Ukraine</Typography>
        <Typography className='email'>info@tellme.place</Typography>
      </Grid>
      <DeleteModal onDelete={onDelete} open={openDeleteText} onClose={onOpenModal} text='you story' />
    </div>
  )

  return (
    <div>
      <Drawer classes={{ paper: classes.paper }} anchor='right' open={openSide} onClose={toggleDrawer('right', false)}>
        {list('right')}
      </Drawer>
    </div>
  )
}

export default SideBar
